import { render } from "./MovieCarousel.vue?vue&type=template&id=01938a66&scoped=true"
import script from "./MovieCarousel.vue?vue&type=script&lang=js"
export * from "./MovieCarousel.vue?vue&type=script&lang=js"

import "./MovieCarousel.vue?vue&type=style&index=0&id=01938a66&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01938a66"]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab});
